import { DEFAULT_CSS_PROPERTIES_LIST } from 'css-in-props'
import { HTML_ATTRIBUTES } from 'attrs-in-props'

const DOMQL_ELEMENTS = [
  'extends',
  'childExtends',
  'children',
  'childProps',
  'childrenAs',
  'state',
  'tag',
  'key',
  'childExtendsRecursive',
  'query',
  'data',
  'scope'
]

export const DOM_EVENTS = [
  'onAnimationcancel',
  'onAnimationend',
  'onAnimationiteration',
  'onAnimationstart',
  'onAuxclick',
  'onBeforeinput',
  'onBeforematchExperimental',
  'onBeforexrselectExperimental',
  'onBlur',
  'onClick',
  'onCompositionend',
  'onCompositionstart',
  'onCompositionupdate',
  'onContentvisibilityautostatechange',
  'onContextmenu',
  'onCopy',
  'onCut',
  'onDblclick',
  'onDOMActivateDeprecated',
  'onFocus',
  'onFocusin',
  'onFocusout',
  'onFullscreenchange',
  'onFullscreenerror',
  'onGotpointercapture',
  'onInput',
  'onKeydown',
  'onKeypressDeprecated',
  'onKeyup',
  'onLostpointercapture',
  'onMousedown',
  'onMouseenter',
  'onMouseleave',
  'onMousemove',
  'onMouseout',
  'onMouseover',
  'onMouseup',
  'onPaste',
  'onPointercancel',
  'onPointerdown',
  'onPointerenter',
  'onPointerleave',
  'onPointermove',
  'onPointerout',
  'onPointerover',
  'onPointerrawupdateExperimental',
  'onPointerup',
  'onScroll',
  'onScrollend',
  'onScrollsnapchangeExperimental',
  'onScrollsnapchangingExperimental',
  'onSecuritypolicyviolation',
  'onTouchcancel',
  'onTouchend',
  'onTouchmove',
  'onTouchstart',
  'onTransitioncancel',
  'onTransitionend',
  'onTransitionrun',
  'onTransitionstart',
  'onWheel'
]

export async function getComponentsList() {
  const list = await this.call('getComponentList', 'components')
  const compList = list.filter(
    ({ isDivider, isSharedLib, isLabel }) =>
      !isDivider && !isSharedLib && !isLabel
  )
  return { title: 'Components', items: compList }
}

export async function getDomqlList() {
  let domElements = DOMQL_ELEMENTS.map((item) => ({ key: item, value: item }))
  return { title: 'Domql', items: domElements.sort() }
}

export async function getEventsList() {
  let domEventsList = DOM_EVENTS.map((item) => ({ key: item, value: item }))
  return { title: 'Events', items: domEventsList.sort() }
}

export async function getCssPropsList() {
  let cssProperties = DEFAULT_CSS_PROPERTIES_LIST.map((item) => ({
    key: item,
    value: item
  }))
  return { title: 'Css', items: cssProperties.sort() }
}

export async function getHTMLAttrsList() {
  let htmlAttributes = HTML_ATTRIBUTES['default'].map((item) => ({
    key: item,
    value: item
  }))
  return { title: 'Html', items: htmlAttributes.sort() }
}

export async function getCategoriesList() {
  const state = this.state
  const filter = state.filterText?.toLowerCase() || ''

  const components = await this.call('getComponentsList')
  const domqlList = await this.call('getDomqlList')
  const eventsList = await this.call('getEventsList')
  const cssPropsList = await this.call('getCssPropsList')
  const htmlAttrsList = await this.call('getHTMLAttrsList')

  let categories

  if (state.parent.listType === 'OnlyProperties') {
    categories = [domqlList, eventsList, cssPropsList, htmlAttrsList]
  } else if (state.parent.listType === 'OnlyChildren') {
    categories = [components]
  } else {
    categories = [
      components,
      domqlList,
      eventsList,
      cssPropsList,
      htmlAttrsList
    ]
  }

  // Apply filter to each category
  return categories
    .map((cat) => ({
      title: cat.title,
      items: cat.items.filter((item) =>
        item.value.toLowerCase().includes(filter)
      )
    }))
    .filter((cat) => cat.items.length > 0)
}

export function moveSelectionInList(dir) {
  const root = this.state.parent
  const title = this.state.title

  const items = this.state.expanded
    ? this.state.items
    : [...this.state.items.slice(0, 5), { value: null, isMore: true }]

  const total = items.length
  let index = items.findIndex((item) =>
    item.isMore ? root.isMoreSelected : item.value === root.selectedItem
  )

  if (dir === 'down') {
    index = index < total - 1 ? index + 1 : 0
  } else if (dir === 'up') {
    index = index > 0 ? index - 1 : total - 1
  }

  const newItem = items[index]

  root.update({
    selectedItem: newItem.value,
    selectedTitle: title,
    isMoreSelected: !!newItem.isMore
  })

  const moreEl = this.parent.lookdown('More')
  if (newItem.isMore) {
    moreEl?.set({ background: 'gray3.5', round: 'Z' })
    this.call('addPropKey', '')
  } else {
    moreEl?.set({ background: 'transparent' })
    this.call('addPropKey', newItem.value)
  }
}

export function addPropKey(key) {
  const panel = this.getFloatingPanelElement()
  const inputEl = panel.inputElement

  if (!inputEl?.node) {
    throw new Error(`Input element ${inputEl} not found`)
  }

  inputEl.node.value = key
}
